import React from 'react';
import {Breadcrumb, Col, Modal, Panel, Row} from "react-bootstrap";
import {IndexLinkContainer, LinkContainer} from "react-router-bootstrap";
import * as qs from 'query-string';
import * as Acl from "./acl";
import * as Grid from './grid';
import * as Enums from "./enums";
import * as Date from "./date";
import * as Files from "./files";

export {Acl};
export {Date};
export {Enums};
export {Files};
export {Grid};
export {qs};

const stubs = {
	'main': 'Dogpoint',
	'page': null,
	'tab': null
};

export const setPageTitle = (text, stub = 'page') => {
	stubs[stub] = text;
	document.title = stubs['main']
		+ (stubs['page'] ? ' | ' + stubs['page'] : '')
		+ (stubs['tab'] ? ' | ' + stubs['tab'] : '')
};

export const breadcrumbs = (crumbs: Array) => {
	const items = [];

	let pageTitle = stubs['main'];
	if (crumbs) {
		for (let i = 0; i < crumbs.length; i++) {
			const title = crumbs[i].literal ? crumbs[i].title : crumbs[i].title;
			if (i + 1 >= crumbs.length) {
				items.push(<Breadcrumb.Item key={i} active>
					{title}
				</Breadcrumb.Item>)
			} else {
				items.push(<LinkContainer key={i} to={crumbs[i].url}>
					<Breadcrumb.Item>
						{title}
					</Breadcrumb.Item>
				</LinkContainer>)
			}
			pageTitle += " | " + title;
		}
	}
	document.title = pageTitle;

	return <Breadcrumb className={"hidden-xs hidden-sm"}>
		<IndexLinkContainer to="/">
			<Breadcrumb.Item>
				Domů
			</Breadcrumb.Item>
		</IndexLinkContainer>
		{items}
	</Breadcrumb>;
};


export const createPartyOption = (w) => {
	let label;
	if (w.partyType === 'PO') {
		label = w.companyName
			+ (w.companyNumber ? ', ' + w.companyNumber : '')
			+ (w.email ? (', ' + w.email) : '');
	} else {
		let n;
		if (w.lastName) {
			n = (w.firstName ? (w.firstName + ' ') : '') + w.lastName;
		} else {
			n = (w.firstName ? w.firstName + ' ' : '') + (w.phone || '')
		}
		label = n
			+ (w.birthDate && Date.getAge(w.birthDate) < 18 ? " (NEZLETILÝ)" : "")
			+ (w.birthDate ? ', ' + Date.formatDate(w.birthDate) : '')
			+ (w.email ? (', ' + w.email) : '');
	}
	return {
		value: w.partyId,
		label,
		info: w
	}
};

export const createDogOption = (w) => {
	return {
		value: w.dogId,
		label: w.name
	}
};

export const createOptions = (values) => {
	return Object.keys(values).map((k) => {
		return {value: k, label: values[k]};
	})
};

export const addNestedError = (errors, key, name, msg) => {
	do {
		const [prefix, ...rest] = key.split('.');
		if (!errors[prefix]) {
			errors[prefix] = {};
		}
		errors = errors[prefix];
		key = rest ? rest.join('.') : null;

	} while (key);

	errors[name] = msg;
}

export const validateAddress = (values, name, errors, needed = true) => {
	if (!values[name] || !values[name]['street']) {
		if (needed) {
			addNestedError(errors, name, 'street', 'Zadejte prosím ulici');
		}
	}
	if (!values[name] || !values[name]['city']) {
		if (needed) {
			addNestedError(errors, name, 'city', 'Zadejte prosím město');
		}
	}
	if (!values[name] || !values[name]['zip']) {
		if (needed) {
			addNestedError(errors, name, 'zip', 'Zadejte prosím PSČ');
		}

	} else if (!/^([0-9]{5,})$/.test(values[name]['zip'].split(' ').join(''))) {
		addNestedError(errors, name, 'zip', 'Neplatné PSČ');
	}
};

export const validateChipNumber = (values, name, errors, needed = true, allowMultiple = false) => {
	if (!values[name]) {
		if (needed) {
			errors[name] = 'Zadejte prosím číslo';
		}
		return;
	}
	const vals = values[name].split(",");
	if (vals.length > 1 && !allowMultiple) {
		errors[name] = 'Zadejte jen jedno číslo';
		return;
	}
	vals.forEach((v) => {
		if (v.trim().length !== 15) {
			errors[name] = 'Hodnota nemá 15 znaků' + (vals.length > 1 ? ' (' + v + ')' : '');
		}
	});
}

export const resolveApiResult = (json, handleApiError = null) => {
	if (json && json.response && json.response.result === 'OK') {
		return true;
	}
	if (handleApiError) {
		handleApiError(json);
	}
	return false;
}

export const executeSequentially = (calls, breakOnError = false, accumulator = []): Promise<any> => {
	return new Promise((resolve) => {
		const nextApiCall = calls.shift();
		if (!nextApiCall) {
			throw new Error("Invalid state - missing next nextApiCall");
		}
		return nextApiCall().then((json) => {
			accumulator.push(json);
			if (breakOnError && !resolveApiResult(json, console.log)) {
				return resolve(json);
			}

			return resolve(calls.length === 0 ? accumulator : executeSequentially(calls, breakOnError, accumulator))
		})
	});
}

export type TText = {
	[string]: {
		tag: string,
		emptyText: string,
		search: string,
		edit: string,
		new: string
	}
}

export type TWrappers = {
	Wrapper: JSX.Element,
	Header: JSX.Element,
	Body: JSX.Element,
	Footer: JSX.Element
}

export const PanelWrappers: TWrappers = {
	Wrapper: (props) => <div>{props.children}</div>,
	Header: Panel.Heading,
	Body: Panel.Body,
	Footer: (props) => <Row><Col>{props.children}</Col></Row>
}

export const ModalWrappers: TWrappers = {
	Wrapper: (props) => <Modal className={props.modal.type + '-modal'} onHide={props.modal.onHide} show={true} backdrop={'static'} keyboard={false}>{props.children}</Modal>,
	Header:(props) => <Modal.Header><Modal.Title>{props.children}</Modal.Title></Modal.Header>,
	Body: Modal.Body,
	Footer: Modal.Footer
}



// WEBPACK FOOTER //
// ./src/utils/index.js